export const fileNameSuffix = () => {
    const date = new Date();
    return `${date.getFullYear()}_${date.getMonth()}_${date.getDate()}_${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}`
}